// src/components/common/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,  
  FaLinkedin
} from 'react-icons/fa';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const services = [
    'Mining Services',
    'Mechanical Services',
    'Electrical Services',
    'Civil Services',
    'Product Supplies',
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h2 className="text-2xl font-bold mb-4">
              <span className="text-white">Brasotech</span>
              <span className="text-blue-400"> Investments</span>
            </h2>
            <p className="text-gray-400 mb-4">
              General Suppliers & Contractors specializing in Civil, Mechanical and Electrical Engineering services.
            </p>
            <div className="flex space-x-4">
              
              <a href="https://www.linkedin.com/company/brasotech-investments-limited/" className="text-gray-400 hover:text-white transition-colors">
                <FaLinkedin className="h-6 w-6" />
              </a>
              
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="h-5 w-5 text-blue-400 mt-1" />
                <span className="text-gray-400">
                  Kitwe, Zambia
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="h-5 w-5 text-blue-400" />
                <a href="tel:+260966801731" className="text-gray-400 hover:text-white">
                  +260 966 801 731
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <FaEnvelope className="h-5 w-5 text-blue-400" />
                <a href="mailto:brasotech@gmail.com" className="text-gray-400 hover:text-white">
                  brasotech@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Brasotech Investments Limited. All rights reserved.
            
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;